<template>
  <div class="navbar__top">
    <LangRouterLink :to="{ name: ROUTES.HOME }" class="navbar__logo">
      <Image :source="$beet.options.hunt.logos[$i18n.locale]" class="navbar__logo-image" />
    </LangRouterLink>
    <div class="navbar__top-right">
      <LangSwitch />
      <button
        v-if="$store.state.auth.logged_in"
        class="navbar__hamburger"
        @click="$emit('toggleIsOpen')"
      >
        <span v-for="i in 3" :key="i" />
      </button>
    </div>
  </div>
</template>

<script>
import { Image, LangRouterLink } from '@/components/global'
import LangSwitch from '@/components/navigation/LangSwitch.vue'
import { UsesRoutesMixin } from '@/mixins'

export default {
  name: 'NavbarTop',
  mixins: [UsesRoutesMixin],
  components: { LangRouterLink, LangSwitch, Image },
  emits: ['toggleIsOpen'],
}
</script>
